module.exports = __webpack_public_path__ + "static/media/image (12).aa95ea90.jpg";